import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const AchievementsPage = lazy(async () => {
  const m = await import("@/features/gamification/components/achievements-page");
  return { default: m.AchievementsPage };
});

/**
 * GAMIFICATION-CORE (UI) — "Achievements": XP/level, streak and badges derived from feed
 * of activity. Opt-in and non-punitive (B2B); private leagues by default.
 */
export const achievementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/achievements",
  component: () => (
    <Suspense fallback={null}>
      <AchievementsPage />
    </Suspense>
  ),
});
